const graphemeSegmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });

/**
 * Channels that measure a caption in UTF-16 code units (what JavaScript's
 * `length` gives), not in what a reader sees as characters: Telegram's
 * 4,096 / 1,024 and TikTok's 2,200. A Malayalam or Hindi character is often
 * two or three units, so a text of 2,000 characters can be over 4,096.
 * X weighs its own way (x-text.ts); YouTube counts UTF-8 bytes (youtube.ts).
 */
export const UTF16_COUNTED_PLATFORMS: ReadonlySet<string> = new Set(['TELEGRAM', 'TIKTOK']);

function graphemeCount(text: string): number {
  let n = 0;
  for (const _ of graphemeSegmenter.segment(text)) n += 1;
  return n;
}

/** The caption's length as `platform` counts it against its limit (X and YouTube excepted, see above). */
export function platformTextLength(platform: string, text: string): number {
  return UTF16_COUNTED_PLATFORMS.has(platform.toUpperCase()) ? text.length : graphemeCount(text);
}
